import jsPDF from "jspdf";
import "jspdf-autotable";

export const downloadInvoicePDF = ({
  delivery,
  user,
  distance,
  duration,
}: any) => {
  const doc = new jsPDF();

  doc.setFontSize(18);
  doc.text("Delivery Invoice", 14, 20);

  doc.setFontSize(12);
  doc.text(`Customer: ${user?.displayName || "N/A"}`, 14, 30);
  doc.text(`Email: ${user?.email || "N/A"}`, 14, 36);
  doc.text(`Pickup: ${delivery.pickup.address}`, 14, 44);
  doc.text(`Dropoff: ${delivery.dropoff.address}`, 14, 50);
  doc.text(`Distance: ${distance}`, 14, 56);
  doc.text(`Duration: ${duration}`, 14, 62);
  doc.text(`Fee: MWK ${delivery.fee.toLocaleString()}`, 14, 70);

  const itemRows =
    delivery.items?.map((item: any, i: number) => [
      i + 1,
      item.name,
      item.qty,
      item.size,
    ]) || [];

  (doc as any).autoTable({
    head: [["#", "Item", "Qty", "Size"]],
    body: itemRows,
    startY: 80,
  });

  doc.save("delivery-invoice.pdf");
};
